import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import EntryListTableExternal from './EntryListTableExternal';

export default class EntryListExternal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: moment(),
    };
    this.updateTime = this.updateTime.bind(this);
  }

  componentDidMount() {
    this.updateTime();
  }

  updateTime() {
    this.setState(
      { time: moment() },
      () => setTimeout(this.updateTime, 1000),
    );
  }

  render() {
    return (
      <div className="entry-list">
        <div className="entry-header">
          <div className="entry-title">External Content</div>
          <div className="entry-caption">Manage and Import new content from an external source.</div>
          <div className="entry-time">{this.state.time.format("dddd, MMMM Do YYYY, h:mm:ss a")}</div>
          <LinkContainer to="/entries/external/create" className="entry-action">
            <Button>Add New Content</Button>
          </LinkContainer>
        </div>
        <div className="entry-body">
          <EntryListTableExternal />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/entry/EntryListExternal.js